import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useHandleManageHostContent } from '../../hooks/useHandleManageHostContent';
import { EmptyState } from '../emptyState';
import { SearchEmptyState } from '../searchEmptyState';
import { DataHubService } from 'src/core/services/datahub';
import { TryContentSearchSchema } from 'src/core/services/datahub/schemas/moduleList/tryContentSearchSchema';
import { useModules } from 'src/modules/contentList/hooks/useModules';
import { Loader } from 'src/shared/components/loader';
import { LoadError } from 'src/shared/components/loadError';
import { StringHelper } from 'src/shared/helpers/string';
import { ModuleList } from './moduleList';
export function List({ searchTerm }) {
    const modulesRequest = useModules();
    useHandleManageHostContent();
    const filteredModules = useMemo(() => {
        if (!modulesRequest.data)
            return [];
        return modulesRequest.data.filter((module) => StringHelper.normalizeText(module.name).includes(StringHelper.normalizeText(searchTerm)));
    }, [modulesRequest.data, searchTerm]);
    useEffect(function dispatchSearchEventEffect() {
        const normalizedSearchTerm = StringHelper.normalizeText(searchTerm);
        if (!normalizedSearchTerm)
            return;
        DataHubService.sendEvent({
            schema: new TryContentSearchSchema({
                text: searchTerm,
                searchResult: filteredModules.length ? 'SUCCESSFUL' : 'FAILURE'
            })
        });
    }, [searchTerm, filteredModules]);
    if (modulesRequest.isLoading) {
        return _jsx(Loader, { full: "width", "data-testid": "content-list-loader" });
    }
    if (modulesRequest.isError) {
        return _jsx(LoadError, { onTryAgain: modulesRequest.refetch });
    }
    if (!modulesRequest.data?.length) {
        return _jsx(EmptyState, {});
    }
    if (!filteredModules?.length) {
        return _jsx(SearchEmptyState, {});
    }
    return _jsx(ModuleList, { modules: filteredModules });
}
